import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { TestProjectDataStore, TestProjectInputEditorStore } from '../../stores';
import TestProjectInputEditDialog from './TestProjectInputEditDialog';
import TestProjectInputMappingDialog from './TestProjectInputMappingDialog';

type Props = {
    store: TestProjectInputEditorStore;
    dataStore: TestProjectDataStore | undefined;
    onMapInputs: () => void;
};

const TestProjectInputEditor: React.FC<Props> = ({ store, dataStore, onMapInputs }) => {
    const draft = store.getDraftFor(dataStore);

    if (!draft) {
        return null;
    }

    if (draft.operation === 'mapping') {
        return <TestProjectInputMappingDialog store={store} draft={draft} onMapInputs={onMapInputs} />;
    }

    return <TestProjectInputEditDialog store={store} draft={draft} onMapInputs={onMapInputs} />;
};

export default observer(TestProjectInputEditor);
